import {isWeb} from "@gluestack-ui/nativewind-utils/IsWeb";
import type React from "react";
import {memo} from "react";

import {BlockCheckinIcon, BlockCheckoutIcon, MoonIcon} from "../../react";
import {HStack} from "../ui/hstack";
import {Text} from "../ui/text";

type Props = {
    kind?: "minNights" | "blockedCheckin" | "blockedCheckout";
    testID?: string;
    text?: string;
    isBoldText?: boolean;
};

const Item: React.FC<Props> = ({testID, text, kind, isBoldText}) => {
    const iconSize = isWeb ? "2xs" : "3xs";
    return (
        <HStack
            className="self-start flex max-w-full items-center justify-center px-0.5 web:py-0.5 overflow-hidden border border-solid border-blueGray-200 rounded-xs"
            space="2xs"
            testID={testID}
        >
            {kind === "minNights" && <MoonIcon fill="blueGray.400" size={iconSize} />}
            {kind === "blockedCheckin" && <BlockCheckinIcon fill="blueGray.400" size={iconSize} />}
            {kind === "blockedCheckout" && (
                <BlockCheckoutIcon fill="blueGray.400" size={iconSize} />
            )}
            {text && (
                <Text
                    bold={isBoldText}
                    color={isBoldText ? "blueGray.600" : "blueGray.400"}
                    numberOfLines={1}
                    variant="2xs"
                >
                    {text}
                </Text>
            )}
        </HStack>
    );
};

export default memo(Item);
